export const SET_INFLIGHT_CASES_STATE_FOR_ENTITY = 'SET_INFLIGHT_CASES_STATE_FOR_ENTITY';
export const CLEAR_INFLIGHT_CASES_STATE_FOR_ALL_ENTITIES = 'CLEAR_INFLIGHT_CASES_STATE_FOR_ALL_ENTITIES';



// WEBPACK FOOTER //
// ./src/components/ViewEntityProfile/actions/actionTypes.js